import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

// React and Framer Motion
import { createRoot } from 'react-dom/client'
import HomePage from './components/HomePage'
import MobileNavMenu from './components/shared/MobileNavMenu'

console.info("Bridgetown is loaded!")

// Mount React application
const container = document.getElementById('root')
if (container) {
  const root = createRoot(container)
  root.render(<HomePage />)
}

// Mount Mobile Nav Menu
const mobileNavContainer = document.getElementById('mobile-nav-menu')
if (mobileNavContainer) {
  const mobileNavRoot = createRoot(mobileNavContainer)
  mobileNavRoot.render(<MobileNavMenu />)
}
